import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

export interface InputProps
	extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
	prefix?: React.ReactNode
	suffix?: React.ReactNode
	name: string
}

const PublicStyledInput = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, prefix, suffix, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'h-14 w-full flex-1 border-b border-brand-dusk bg-transparent px-1 pb-1 font-serif text-[clamp(25px,calc(2vw+1rem),3rem)] font-light leading-[clamp(25px,calc(2vw+1rem),3rem)] transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-brand-dusk/85 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 xl:pb-3',
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)
PublicStyledInput.displayName = 'PublicStyledInput'

const PublicInput = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, prefix, suffix, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'h-14 w-full flex-1 border-b border-brand-dusk bg-transparent text-body-2xs font-light tracking-widest transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:uppercase placeholder:text-brand-dusk/85 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 xl:pb-3 xl:text-body-xs',
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)
PublicInput.displayName = 'PublicInput'

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, prefix, suffix, type, ...props }, ref) => {
		return (
			<div
				className={cn(
					'relative flex min-h-10 w-full items-center border border-input bg-background px-2 py-1 shadow-sm focus-within:ring-1 focus-within:ring-ring',
					props.disabled && 'opacity-30',
				)}
			>
				{prefix && prefix}
				<input
					type={type}
					className={cn(
						'h-full w-full flex-1 bg-transparent px-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-medium placeholder:text-neutral-400 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
						className,
					)}
					ref={ref}
					{...props}
				/>
				{suffix && suffix}
			</div>
		)
	},
)
Input.displayName = 'Input'

export { Input, PublicInput, PublicStyledInput }
